export const environment = {
  production: false,
  name: 'Staging',
  jwt: {
    whitelist: ['staging.atom.digitalvirgo.com'],
  },
  api: 'https://staging.atom.digitalvirgo.com',
  version: 'atom.v1',
  forgottenPasswordUrl:
    'https://dv-access.com?origin=https://dashboard-atom.dve-dev.com',
};
